<template>
 
  <v-btn flat :to="link">           
    <v-icon left>{{icon}}</v-icon> {{title}}
  </v-btn>   
  
</template>

<script>
export default {
 name: 'v-btnMenu',
  props: {
    title: {
      type: String,
    },
    icon: {
      type: String,
    },  
    link: {
      type: String,
      default: '/'
    },    
  },

  data () {
    return {

    };
  },
  computed: {

  },  
};
</script>